<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>{{ $t("navigations.lab tests") }}</h2>
    </div>
        <div class="col-lg-2">
            <span class="tooltip-wrapper pointer" style="float:right">
                <i class="fa fa-times close" @click="onclosed()"></i>
                <span class="custom-tooltip closetooltipposition">Close</span>
            </span>
        </div>
  </div>
  <div class="wrapper wrapper-content">
    <div class="d-flex flex-column flex-lg-row justify-content-lg-start my-2 my-lg-0">
    </div>
    <div class="ibox-body">
      <div class="ibox-title style_2 d-flex justify-content-between">
        <h5>{{ $t("navigations.assign lab test") }}</h5>
        <button type="button" class="btn btn-primary btn-sm py-0 px-3 mt-2" @click="assignTest">
          {{ $t("navigations.assign test") }}
        </button>
      </div>


      <div class="ibox-content">
        <div class="text-center" v-if="showLoading === true">
          <img src="../../assets/img/loading.gif" width="15" alt="Loading" />
          <div>{{ $t("navigations.please wait while the list is being loaded") }}</div>
        </div>
        <template v-else>
          <div class="text-center" v-if="labList.length == 0">
            {{ $t('navigations.no data available') }}
          </div>
          <div v-else class="table-responsive">
            <table class="table table-striped table-bordered dataTables">
              <thead>
                <tr>
                  <th>{{ $t("navigations.test code") }}</th>
                  <th>{{ $t("navigations.test name") }}</th>
                  <th>{{ $t("navigations.unit") }}</th>
                  <th>{{ $t("navigations.category") }}</th>
                  <th>{{ $t("navigations.method") }}</th>
                  <th>{{ $t("navigations.cdisc variable") }}</th>
                  <th>{{ $t("navigations.fhir resource") }}</th>
                  <th class="text-center"> {{ $t("navigations.lab reference") }}</th>
                   <!-- <th class="text-center"> {{ $t("navigations.version") }}</th> -->
                    <!-- <th class="text-center"> {{ $t("navigations.validation") }}</th> -->


                </tr>
              </thead>
              <tbody>
                <tr v-for="lab in labList" :key="lab.testId || lab.id">
                  <td>{{ lab.testCode }}</td>
                  <td>{{ lab.testName }}</td>
                  <td>{{ lab.unit }}</td>
                  <td>{{ lab.category }}</td>
                  <td>{{ lab.method }}</td>
                  <td>{{ lab.cdiscVariable }}</td>
                  <td>{{ lab.fhirResource }}</td>
                  <td class="text-center">
                    <i class="fa fa-edit edit-delete" @click.prevent="openSetrangeModal(lab.testCode, lab.unit, lab.cdiscVariable)">
                    </i>
                  </td>
                    <!-- <td class="text-center">
                    <i class="fa fa-external-link-square edit-delete" @click.prevent="openVersionModal(lab.testCode)">
                    </i>
                  </td> -->
                  <!-- <td class="text-center">
                    <i class="fa fa-edit edit-delete" @click.prevent="openValidationModal(lab)">
                    </i>
                  </td> -->
                </tr>
              </tbody>
            </table>
                       <div class="col-md-12 d-flex justify-content-md-end px-0" v-if="labList.length!=0">
              <VPagination
                v-model="currentPage"
                :pages="totalItems"
                :range-size="1"
                active-color="#ededed"
                @update:modelValue="loadPage"
              />
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
  <!-- <setTestRanges
  v-if="showSetRange"
  :showSetRange="showSetRange"
  @closeModal="closeSetRangeModal"
/> -->

<setTestRanges v-if="showSetRange" 
  :showSetRange="showSetRange" 
  :labCode="selectedLabCode"
    :testCode="selectedTestCode" 
    
    :cdiscVariable="cdiscVariable"
    @closeModal="closeSetRangeModal" />
 <!-- Lab Test Popup -->
    <assignTestModal
      v-if="showLabPopup"
      :showLoading="showLoading"
       :currentVersion="currentVersion"
      :labCode="PropsLabCode"
      @close="showLabPopup = false"
       @saved="refreshLabTestList"
    
    />

    <!-- Lab Test Version Popup -->

        <LabTestVersionModal
      v-if="showLabVersionPopup"
  :showLoading="showLoading"
  :labCode="PropsLabCode"
  :testCode="selectedTestCode"
  :oldVersionNo="selectedVersion"
  :currentVersion="currentVersion"
 
  :studyId="studyId"
  @close="showLabVersionPopup = false"
  @saved="refreshLabTestList"
  @showSetVersion="showSetVersion = true"
/>
      <!-- Version Popup -->
<!-- <setTestRanges
  v-if="showSetVersion"
  :showSetVersion="showSetVersion"
  :labCode="selectedLabCode"
  :cdiscVariable="cdiscVariable"
  :testCode="selectedTestCode"
  :unitselected="passedunit"
  :currentVersion="currentVersion"
  @closeModal="closeSetVersionModal"
/> -->
<!-- <labValidationRule
  v-if="showValidationRule"
  :labCode="selectedLabCode"
  :testCode="selectedTestCode"
  :ruleName="selectedRuleName"
  :ruleCode="selectedRuleCode"
  @closeModal="closeValidation"
/> -->


<!-- lab test popup end -->
</template>
<script src="./assignTest.js">
import LabTestVersionModal from './LabTestVersionModal.vue';

</script>
<style scoped>
@import "../../assets/style.css";
@import "../../assets/formpage.css";

.wrap-table-cell {
  min-width: 70ch;
  text-wrap-mode: wrap
}

input :disabled {
  cursor: not-allowed;
  opacity: 1;
}

.previousbtn,
.nextbtn {
  margin: 0;
  border-radius: 0px;
  border: 0.5px solid #eeeeee;
}

.page-links {
  border-radius: 0px;
}

.form-select {
  border-radius: 0 !important;
}

.form-select:focus {
  border-color: #145faf !important;
  box-shadow: 0 0 0 !important;
}

.position-relative img {
  width: 20px;
}

.cursor-pointer {
  cursor: pointer;
}

.position-relative {
  position: relative;
}

.position-relative .tool-tip {
  visibility: hidden;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.1rem 0.8rem;
  right: 0;
  top: -30px;
  font-size: 0.8rem;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  -webkit-transition: visibility 75ms ease-in;
  transition: visibility 75ms ease-in;
}

.position-relative:hover .tool-tip,
.position-relative:focus-visible .tool-tip {
  visibility: visible;
  -webkit-transition: visibility 30ms ease-in;
  transition: visibility 30ms ease-in;
}

.modal__container22 {
  width: 33%;
  max-width: 30%;
  position: fixed;
  height: 20% !important;
  margin-top: -550px !important;
  margin-left: 409px !important;
  background: rgb(255, 255, 255);
  border-radius: 4px;
  transition: all 0.3s ease-in-out 0s;
}

.modal__container23 {
  width: 66%;
  max-width: 62%;
  position: fixed;
  height: -14% !important;
  margin-top: -683px !important;
  margin-left: 140px !important;
  background: rgb(255, 255, 255);
  border-radius: 4px;
  transition: all 0.3s ease-in-out 0s;
}

.scrollable3 {
  overflow-y: scroll;
  height: 250px;
}

.audit__details__modal__wrapper {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 3000
}

.audit__details__modal__container {
  width: min(90%, 365px);
  position: fixed;
  background: rgb(255, 255, 255);
  border-radius: 4px;
  overflow-y: hidden;
}

.audit__details__modal__title,
.audit__history__modal__title {
  background-color: var(--pop-up-background);
  color: #ffffff;
}

.heightBig {
  overflow-y: scroll;
  height: 250px;
}

.audit__history__modal__contents {
  overflow-y: scroll;
  height: 404px;
}

.audit__history__modal__wrapper {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 4000
}

.audit__history__modal__container {
  width: min(45%, 90%);
  position: fixed;
  background: rgb(255, 255, 255);
  border-radius: 4px;
  overflow-y: hidden;
}
</style>